<div class="layout-section">
  <div class="table-wrapper">
    <div class="table-header gap-4">
      <div class="align-items-center flex">
        <div>
          <button
            pButton
            pRipple
            type="button"
            class="p-button-rounded p-button-text reload-btn"
            (click)="getLayouts()"
          ></button>
        </div>
        <h2>Layouts</h2>
        <div class="user-label">
          <img class="layout-header-icon" alt="layout-icon" src="../../assets/images/layout.svg" />
          <span>{{ totalLayouts }}</span>
        </div>
      </div>

      <div class="align-items-center flex">
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon">
            <img alt="search.svg" src="../../assets/images/search.svg" />
          </span>
          <input
            (keyup)="onSearchKeyup()"
            [(ngModel)]="searchInput"
            class="table-search-field"
            placeholder="Search layouts"
            type="text"
          />
        </div>
        <p-button
          (click)="openAddDialog()"
          label="Create Layout"
          styleClass="button-sm add-icon"
        ></p-button>
      </div>
    </div>

    <p-table
      [rowHover]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfRecordsPerRow"
      [showCurrentPageReport]="true"
      [value]="layouts"
    >
      <ng-template pTemplate="header">
        <tr class="gc-table-filter">
          <th id="apps-info" [width]="'250px'">App Packages</th>
          <th id="version" [width]="'100px'">Version</th>
          <th id="layout-count" [width]="'120px'">Layouts</th>
          <th id="app-count" [width]="'120px'">Apps</th>
          <th id="created-at" [width]="'180px'">Created At</th>
          <th id="updated-at" [width]="'180px'">Updated At</th>
          <th id="actions" [width]="'160px'" class="text-center">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td class="wrap-text">
            <span *ngIf="rowData.apps && rowData.apps.length > 0">
              <span *ngFor="let app of rowData.apps; let i = index">
                {{ app.package }}<span *ngIf="i < rowData.apps.length - 1">, </span>
              </span>
            </span>
            <span *ngIf="!rowData.apps || rowData.apps.length === 0" class="text-muted">-</span>
          </td>
          <td class="wrap-text">
            {{ rowData.version }}
          </td>
          <td class="wrap-text">
            {{ rowData.layouts?.length || 0 }}
          </td>
          <td class="wrap-text">
            {{ rowData.apps?.length || 0 }}
          </td>
          <td class="wrap-text">
            {{ rowData.createdAt | date:'MM/dd/yyyy HH:mm' }}
          </td>
          <td class="wrap-text">
            {{ rowData.updatedAt | date:'MM/dd/yyyy HH:mm' }}
          </td>
          <td class="text-center" (click)="$event.stopPropagation()">
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                pButton
                type="button"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text p-button-info"
                pTooltip="Edit Layout"
                tooltipPosition="left"
                (click)="onEditLayout($event, rowData)"
              ></button>
              <button
                pButton
                type="button"
                icon="pi pi-download"
                class="p-button-rounded p-button-text p-button-info"
                pTooltip="Download Layout JSON"
                tooltipPosition="left"
                (click)="onDownloadLayoutJson($event, rowData)"
              ></button>
              <button
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-text p-button-danger"
                pTooltip="Delete Layout"
                tooltipPosition="left"
                (click)="onDelete(rowData)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            <span>
              <em class="pi pi-exclamation-circle mr-2"></em>
              No Layouts configured
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div>
      <p-paginator
        (onPageChange)="paginate($event)"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [rows]="noOfRecordsPerRow"
        [totalRecords]="totalLayouts"
        styleClass="gc-paginator"
      ></p-paginator>
    </div>
  </div>
</div>

<p-sidebar
  [(visible)]="dialogVisible"
  position="right"
  [showCloseIcon]="false"
  [dismissible]="!isBusy"
  [closeOnEscape]="!isBusy"
  appendTo="body"
  (onHide)="onDialogHide()"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">{{ isEditMode ? 'Update Layout' : 'Create Layout' }}</h2>
      <span
        (click)="isBusy ? null : onDialogHide()"
        class="cursor-pointer"
        [class.disabled]="isBusy"
        [style.pointer-events]="isBusy ? 'none' : 'auto'"
        [style.opacity]="isBusy ? '0.5' : '1'"
      >
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="popup-wrapper" *ngIf="layoutForm">
      <div *ngIf="isBusy" class="sidebar-interaction-blocker"></div>
      <div class="form-container">
        <form [formGroup]="layoutForm">
          <div class="sidebar-form">
            <!-- JSON File Upload Section (only show in create mode) -->
            <div class="gc-form-section" *ngIf="!isEditMode">
              <div class="gc-form-section-heading">
                <h3>Upload Layout JSON</h3>
              </div>
              <div class="sidebar-form">
                <!-- Drag & drop zone when no file -->
                <div *ngIf="!selectedJsonFile" class="dropzone" fileDragDrop>
                  <div class="text-wrapper">
                    <div class="dropFile-wra">
                      <input
                        id="layoutJsonFile"
                        name="layoutJsonFile"
                        type="file"
                        accept=".json"
                        (change)="onJsonFileSelected($event)"
                        [disabled]="isBusy"
                      />
                      <div class="flex flex-column align-items-center justify-content-center gap-4">
                        <img alt="File upload" src="../../assets/images/fileupload.svg" />
                        <label class="textLink" for="layoutJsonFile">
                          Drag and drop JSON file here or <u>Choose file</u>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Progress bar during processing -->
                <p-progressBar
                  *ngIf="uploadProgressBar"
                  [value]="uploadProgressValue"
                  [showValue]="true"
                  class="esco-progressBar"
                ></p-progressBar>

                <!-- Uploaded file info -->
                <div *ngIf="selectedJsonFile" class="fileupload-info">
                  <div class="flex align-items-center gap-3 w-8">
                    <img alt="" src="../../assets/images/Document.svg" />
                    <label class="fileupload-text">{{ uploadedFileName || selectedJsonFile.name }}</label>
                  </div>
                  <div class="flex align-items-center gap-3">
                    <button
                      type="button"
                      class="btn-cancel p-button button-sm"
                      pButton
                      (click)="clearSelectedFile()"
                      [disabled]="isBusy"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Version -->
            <div class="gc-form-section">
              <div class="gc-form-section-heading" [class.collapsed]="collapsedSections.version">
                <h3 class="m-0 cursor-pointer" (click)="toggleSection('version')">Version</h3>
                <i
                  class="pi cursor-pointer"
                  [ngClass]="collapsedSections.version ? 'pi-chevron-right' : 'pi-chevron-down'"
                  (click)="toggleSection('version')"
                ></i>
              </div>
              <div class="sidebar-form" *ngIf="!collapsedSections.version">
                <div class="grid p-fluid">
                  <div class="col-12 mb-0">
                    <input
                      pInputText
                      formControlName="version"
                      type="number"
                      min="1"
                      [disabled]="true"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Apps Section -->
            <div class="gc-form-section">
              <div class="gc-form-section-heading" [class.collapsed]="collapsedSections.apps">
                <h3 class="m-0 cursor-pointer" (click)="toggleSection('apps')">Apps</h3>
                <div class="flex align-items-center gap-2">
                  <p-button
                    *ngIf="!collapsedSections.apps"
                    (click)="addApp(); $event.stopPropagation()"
                    label="Add App"
                    styleClass="button-sm add-icon"
                    [disabled]="isBusy"
                  ></p-button>
                  <i
                    class="pi cursor-pointer"
                    [ngClass]="collapsedSections.apps ? 'pi-chevron-right' : 'pi-chevron-down'"
                    (click)="toggleSection('apps')"
                  ></i>
                </div>
              </div>

              <div class="sidebar-form" *ngIf="!collapsedSections.apps">
                <div formArrayName="apps">
                  <div
                    *ngFor="let app of appsFormArray.controls; let i = index"
                    [formGroupName]="i"
                    class="nested-form-group"
                  >
                    <div class="flex justify-content-between align-items-center mb-3">
                      <h4 class="m-0 cursor-pointer flex align-items-center gap-2" (click)="toggleApp(i)">
                        <i class="pi" [ngClass]="isAppCollapsed(i) ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
                        App {{ i + 1 }}
                      </h4>
                      <button
                        pButton
                        type="button"
                        *ngIf="appsFormArray.length > 1"
                        (click)="removeApp(i)"
                        icon="pi pi-trash"
                        class="p-button-text p-button-danger"
                        [disabled]="isBusy"
                      ></button>
                    </div>

                    <div class="grid p-fluid" *ngIf="!isAppCollapsed(i)">
                      <div class="col-12 mb-2">
                        <label>Package<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="package"
                          placeholder="e.g., com.hchb.pc.ui"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <label>Package Revision<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="version"
                          placeholder="e.g., 24.5.X"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <label>Min Package Revision<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="minVersion"
                          placeholder="e.g., 23.X.X"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12">
                        <label>Max Package Revision<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="maxVersion"
                          placeholder="e.g., 25.X.X"
                          [disabled]="isBusy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Layouts Section -->
            <div class="gc-form-section">
              <div class="gc-form-section-heading" [class.collapsed]="collapsedSections.layouts">
                <h3 class="m-0 cursor-pointer" (click)="toggleSection('layouts')">Layouts</h3>
                <div class="flex align-items-center gap-2">
                  <p-button
                    *ngIf="!collapsedSections.layouts"
                    (click)="addLayout(); $event.stopPropagation()"
                    label="Add Layout"
                    styleClass="button-sm add-icon"
                    [disabled]="isBusy"
                  ></p-button>
                  <i
                    class="pi cursor-pointer"
                    [ngClass]="collapsedSections.layouts ? 'pi-chevron-right' : 'pi-chevron-down'"
                    (click)="toggleSection('layouts')"
                  ></i>
                </div>
              </div>

              <div class="sidebar-form" *ngIf="!collapsedSections.layouts">
                <div formArrayName="layouts">
                  <div
                    *ngFor="let layout of layoutsFormArray.controls; let i = index"
                    [formGroupName]="i"
                    class="nested-form-group"
                  >
                    <div class="flex justify-content-between align-items-center mb-3">
                      <h4 class="m-0 cursor-pointer flex align-items-center gap-2" (click)="toggleLayout(i)">
                        <i class="pi" [ngClass]="isLayoutCollapsed(i) ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
                        Layout {{ i + 1 }} – {{ layout.get('layoutType')?.value }}
                      </h4>
                      <button
                        pButton
                        type="button"
                        *ngIf="layoutsFormArray.length > 1"
                        (click)="removeLayout(i)"
                        icon="pi pi-trash"
                        class="p-button-text p-button-danger"
                        [disabled]="isBusy"
                      ></button>
                    </div>

                    <div class="grid p-fluid" *ngIf="!isLayoutCollapsed(i)">
                      <div class="col-12 mb-2">
                        <label>Layout Type<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="layoutType"
                          placeholder="e.g., grid"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <label>Priority<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="priority"
                          type="number"
                          min="1"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12 mb-2">
                        <div class="flex align-items-center gap-2">
                          <p-checkbox
                            [binary]="true"
                            formControlName="critical"
                            inputId="critical{{ i }}"
                            styleClass="checkbox-cursor-pointer"
                            [disabled]="isBusy"
                          ></p-checkbox>
                          <label [for]="'critical' + i" class="m-0 cursor-pointer">Critical</label>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <label>Alert Probability<span class="red">*</span></label>
                        <input
                          pInputText
                          formControlName="alertProbability"
                          type="number"
                          min="0"
                          max="1"
                          step="0.1"
                          [disabled]="isBusy"
                        />
                      </div>
                      <div class="col-12">
                        <label>Context Type</label>
                        <p-dropdown
                          formControlName="contextType"
                          [options]="['SingleScreen', 'MultiScreen']"
                          placeholder="Select context type"
                          [disabled]="isBusy"
                          [showClear]="true"
                        ></p-dropdown>
                      </div>
                      <div class="col-12 mt-2">
                        <label>Screen Context</label>
                        <input
                          pInputText
                          formControlName="screenContext"
                          placeholder="e.g., demographics"
                          [disabled]="isBusy"
                        />
                      </div>
                    </div>

                    <!-- Conditions -->
                    <div class="gc-form-section mt-4" *ngIf="!isLayoutCollapsed(i)">
                      <div class="gc-form-section-heading" [class.collapsed]="isConditionsCollapsed(i)">
                        <h4 class="m-0 cursor-pointer" (click)="toggleConditions(i)">Conditions</h4>
                        <div class="flex align-items-center gap-2">
                          <p-button
                            *ngIf="!isConditionsCollapsed(i)"
                            (click)="addCondition(i); $event.stopPropagation()"
                            label="Add"
                            styleClass="button-sm add-icon"
                            [disabled]="isBusy"
                          ></p-button>
                          <i
                            class="pi cursor-pointer"
                            [ngClass]="isConditionsCollapsed(i) ? 'pi-chevron-right' : 'pi-chevron-down'"
                            (click)="toggleConditions(i)"
                          ></i>
                        </div>
                      </div>

                      <div class="sidebar-form" *ngIf="!isConditionsCollapsed(i)">
                        <div formArrayName="conditions">
                          <div
                            *ngFor="let condition of getConditionsFormArray(i).controls; let j = index"
                            [formGroupName]="j"
                            class="nested-form-group"
                          >
                            <div class="flex justify-content-between align-items-center mb-3">
                              <h5 class="m-0 cursor-pointer flex align-items-center gap-2" (click)="toggleCondition(i, j)">
                                <i class="pi" [ngClass]="isConditionCollapsed(i, j) ? 'pi-chevron-right' : 'pi-chevron-down'"></i>
                                Condition {{ j + 1 }}
                              </h5>
                              <button
                                pButton
                                type="button"
                                *ngIf="getConditionsFormArray(i).length > 1"
                                (click)="removeCondition(i, j)"
                                icon="pi pi-trash"
                                class="p-button-text p-button-danger"
                                [disabled]="isBusy"
                              ></button>
                            </div>

                            <div class="grid p-fluid" *ngIf="!isConditionCollapsed(i, j)">
                              <!-- Condition Type -->
                              <div class="col-12 mb-2">
                                <label>Type<span class="red">*</span></label>
                                <p-dropdown
                                  formControlName="type"
                                  [options]="['CHILD_COUNT', 'CLASS_NAME', 'TEXT_MATCH', 'CHILDREN', 'LIST', 'LAYOUT', 'OR', 'NOT', 'META']"
                                  placeholder="Select condition type"
                                  [disabled]="isBusy"
                                ></p-dropdown>
                              </div>

                              <!-- Description (common to all) -->
                              <div class="col-12 mb-2">
                                <label>Description</label>
                                <input
                                  pInputText
                                  formControlName="description"
                                  placeholder="Optional description"
                                  [disabled]="isBusy"
                                />
                              </div>
                              <div class="col-12 mb-2">
                                <div class="flex align-items-center gap-2">
                                  <p-checkbox
                                    [binary]="true"
                                    formControlName="readOnly"
                                    [inputId]="'readOnly' + i + j"
                                    [disabled]="isBusy"
                                  ></p-checkbox>
                                  <label [for]="'readOnly' + i + j" class="m-0 cursor-pointer">Read Only</label>
                                </div>
                              </div>

                              <!-- CHILD_COUNT fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'CHILD_COUNT'">
                                <div class="col-12 mb-2">
                                  <label>Min</label>
                                  <input
                                    pInputText
                                    formControlName="min"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Max</label>
                                  <input
                                    pInputText
                                    formControlName="max"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                              </ng-container>

                              <!-- CLASS_NAME fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'CLASS_NAME'">
                                <div class="col-12 mb-2">
                                  <label>Values<span class="red">*</span></label>
                                  <div formArrayName="values">
                                    <div
                                      *ngFor="let value of getConditionValuesArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        placeholder="e.g., android.widget.TextView"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="removeConditionValue(i, j, k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                            <p-button
                                              (click)="addConditionValue(i, j)"
                                              label="Add Value"
                                              styleClass="btn-cancel p-button-sm"
                                              [disabled]="isBusy"
                                            ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Index</label>
                                  <input
                                    pInputText
                                    formControlName="index"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Indices</label>
                                  <div formArrayName="indices">
                                    <div
                                      *ngFor="let idx of getConditionIndicesArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        type="number"
                                        placeholder="e.g., -1"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="removeConditionIndex(i, j, k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                    <p-button
                                      (click)="addConditionIndex(i, j)"
                                      label="Add Index"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Regex</label>
                                  <input
                                    pInputText
                                    formControlName="regex"
                                    placeholder="e.g., ^Visit:\\s*(\\d+)$"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                      [binary]="true"
                                      formControlName="reverseSearch"
                                      [inputId]="'reverseSearch' + i + j"
                                      [disabled]="isBusy"
                                    ></p-checkbox>
                                    <label [for]="'reverseSearch' + i + j" class="m-0 cursor-pointer">Reverse Search</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Tag</label>
                                  <input
                                    pInputText
                                      [formControl]="$any(getConditionRefFormGroup(i, j).get('tag'))"
                                    placeholder="e.g., patient_name"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Index</label>
                                  <input
                                    pInputText
                                      [formControl]="$any(getConditionRefFormGroup(i, j).get('index'))"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Ref Relative Index</label>
                                  <input
                                    pInputText
                                      [formControl]="$any(getConditionRefFormGroup(i, j).get('relativeIndex'))"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mt-2">
                                  <label>Ref Regex</label>
                                  <input
                                    pInputText
                                      [formControl]="$any(getConditionRefFormGroup(i, j).get('regex'))"
                                    placeholder="Optional ref regex"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mt-2">
                                  <label>Ref Value Regex</label>
                                  <input
                                    pInputText
                                      [formControl]="$any(getConditionRefFormGroup(i, j).get('valueRegex'))"
                                    placeholder="Optional ref valueRegex"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mt-2">
                                  <label>Ref Context</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                </div>
                              </ng-container>

                              <!-- TEXT_MATCH fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'TEXT_MATCH'">
                                <div class="col-12 mb-2">
                                  <label>Values<span class="red">*</span></label>
                                  <div formArrayName="values">
                                    <div
                                      *ngFor="let value of getConditionValuesArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        placeholder="e.g., Next"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="removeConditionValue(i, j, k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                            <p-button
                                              (click)="addConditionValue(i, j)"
                                              label="Add Value"
                                              styleClass="btn-cancel p-button-sm"
                                              [disabled]="isBusy"
                                            ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Indices</label>
                                  <div formArrayName="indices">
                                    <div
                                      *ngFor="let idx of getConditionIndicesArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        type="number"
                                        placeholder="e.g., -1"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="removeConditionIndex(i, j, k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                    <p-button
                                      (click)="addConditionIndex(i, j)"
                                      label="Add Index"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                      [binary]="true"
                                      formControlName="exact"
                                      [inputId]="'exact' + i + j"
                                      [disabled]="isBusy"
                                    ></p-checkbox>
                                    <label [for]="'exact' + i + j" class="m-0 cursor-pointer">Exact Match</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                      [binary]="true"
                                      formControlName="reverseSearch"
                                      [inputId]="'textMatchReverseSearch' + i + j"
                                      [disabled]="isBusy"
                                    ></p-checkbox>
                                    <label [for]="'textMatchReverseSearch' + i + j" class="m-0 cursor-pointer">Reverse Search</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Class Name</label>
                                  <input
                                    pInputText
                                    formControlName="className"
                                    placeholder="e.g., android.widget.Button"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Regex</label>
                                  <input
                                    pInputText
                                    formControlName="regex"
                                    placeholder="e.g., ^(1[0-2]|0?[1-9])/(3[01]|[0-2][0-9]|0?[1-9])$"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Tag</label>
                                  <input
                                    pInputText
                                    [formControl]="$any(getConditionRefFormGroup(i, j).get('tag'))"
                                    placeholder="e.g., next_button"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Relative Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Context</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Regex</label>
                                  <input
                                    pInputText
                                    [formControl]="$any(getConditionRefFormGroup(i, j).get('regex'))"
                                    placeholder="Optional ref regex"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Value Regex</label>
                                  <input
                                    pInputText
                                    [formControl]="$any(getConditionRefFormGroup(i, j).get('valueRegex'))"
                                    placeholder="Optional ref valueRegex"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Index</label>
                                  <input
                                    pInputText
                                    formControlName="index"
                                    type="number"
                                    [disabled]="isBusy"
                                  />
                                </div>
                              </ng-container>

                              <!-- CHILDREN fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'CHILDREN'">
                                <div class="col-12 mb-2">
                                  <label>Target Conditions</label>
                                  <div formArrayName="target">
                                    <div
                                      *ngFor="let target of getConditionTargetArray(i, j).controls; let k = index"
                                      [formGroupName]="k"
                                      class="nested-form-group mb-3 p-3 border-round"
                                      style="background-color: #f8f9fa;"
                                    >
                                      <div class="flex justify-content-between align-items-center mb-2">
                                        <h6>Target {{ k + 1 }}</h6>
                                        <p-button
                                          (click)="getConditionTargetArray(i, j).removeAt(k)"
                                          icon="pi pi-trash"
                                          styleClass="p-button-text p-button-danger p-button-sm"
                                          [disabled]="isBusy"
                                        ></p-button>
                                      </div>
                                      <div class="grid p-fluid">
                                        <div class="col-12 mb-2">
                                          <label>Type<span class="red">*</span></label>
                                          <p-dropdown formControlName="type" [options]="['CLASS_NAME', 'TEXT_MATCH', 'CHILD_COUNT', 'META']" placeholder="Select type" [disabled]="isBusy"></p-dropdown>
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Description</label>
                                          <input pInputText formControlName="description" placeholder="Optional description" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <div class="flex align-items-center gap-2">
                                            <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'childrenTargetReadOnly' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                            <label [for]="'childrenTargetReadOnly' + i + j + k" class="m-0 cursor-pointer">Read Only</label>
                                          </div>
                                        </div>
                                        <ng-container *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CLASS_NAME' || getConditionTargetArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                          <div class="col-12 mb-2">
                                            <label>Values</label>
                                            <div formArrayName="values">
                                              <div *ngFor="let value of getTargetValuesArray(i, j, k).controls; let v = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="v" placeholder="e.g., android.widget.TextView" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeTargetValue(i, j, k, v)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addTargetValue(i, j, k)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Index</label>
                                            <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Indices</label>
                                            <div formArrayName="indices">
                                              <div *ngFor="let idx of getTargetIndicesArray(i, j, k).controls; let idxI = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="idxI" type="number" placeholder="e.g., 2" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeTargetIndex(i, j, k, idxI)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addTargetIndex(i, j, k)" label="Add Index" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CLASS_NAME'">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'targetReverseSearch' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'targetReverseSearch' + i + j + k" class="m-0 cursor-pointer">Reverse Search</label>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <label>Regex</label>
                                            <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                          </div>
                                        </ng-container>
                                        <div class="col-12 mb-2" *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Min</label>
                                          <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2" *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Max</label>
                                          <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Tag</label>
                                          <input pInputText [formControl]="$any(getTargetRefFormGroup(i, j, k).get('tag'))" placeholder="e.g., quiz_widgets_container" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Index</label>
                                          <input pInputText [formControl]="$any(getTargetRefFormGroup(i, j, k).get('index'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12">
                                          <label>Ref Relative Index</label>
                                          <input
                                            pInputText
                                              [formControl]="$any(getTargetRefFormGroup(i, j, k).get('relativeIndex'))"
                                            type="number"
                                            [disabled]="isBusy"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p-button
                                      (click)="getConditionTargetArray(i, j).push(createConditionFormGroup())"
                                      label="Add Target"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Nested Conditions</label>
                                  <div formArrayName="conditions">
                                    <div
                                      *ngFor="let nestedCondition of getConditionConditionsArray(i, j).controls; let k = index"
                                      [formGroupName]="k"
                                      class="nested-form-group mb-3 p-3 border-round"
                                      style="background-color: #f8f9fa;"
                                    >
                                      <div class="flex justify-content-between align-items-center mb-2">
                                        <h6>Condition {{ k + 1 }}</h6>
                                        <p-button
                                          (click)="removeNestedCondition(i, j, k)"
                                          icon="pi pi-trash"
                                          styleClass="p-button-text p-button-danger p-button-sm"
                                          [disabled]="isBusy"
                                        ></p-button>
                                      </div>
                                      <div class="grid p-fluid">
                                        <div class="col-12 mb-2">
                                          <label>Type<span class="red">*</span></label>
                                          <p-dropdown formControlName="type" [options]="['CHILD_COUNT', 'CLASS_NAME', 'TEXT_MATCH', 'CHILDREN', 'LIST', 'OR', 'NOT', 'META']" placeholder="Select type" [disabled]="isBusy"></p-dropdown>
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Description</label>
                                          <input pInputText formControlName="description" placeholder="Optional description" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <div class="flex align-items-center gap-2">
                                            <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'childrenNestedReadOnly' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                            <label [for]="'childrenNestedReadOnly' + i + j + k" class="m-0 cursor-pointer">Read Only</label>
                                          </div>
                                        </div>
                                        <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Min</label>
                                          <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Max</label>
                                          <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                        </div>
                                        <ng-container *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CLASS_NAME' || getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                          <div class="col-12 mb-2">
                                            <label>Values</label>
                                            <div formArrayName="values">
                                              <div *ngFor="let value of getNestedConditionValuesArray(i, j, k).controls; let v = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="v" placeholder="e.g., android.widget.TextView" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeNestedConditionValue(i, j, k, v)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addNestedConditionValue(i, j, k)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Index</label>
                                            <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="exact" [inputId]="'nestedExact' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'nestedExact' + i + j + k" class="m-0 cursor-pointer">Exact Match</label>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'nestedReverseSearch' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'nestedReverseSearch' + i + j + k" class="m-0 cursor-pointer">Reverse Search</label>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <label>Class Name</label>
                                            <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <label>Regex</label>
                                            <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                          </div>
                                        </ng-container>
                                        <div class="col-12 mb-2">
                                          <label>Ref Tag</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('tag'))" placeholder="e.g., correction_accept_button" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Index</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('index'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Relative Index</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Context</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Regex</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('regex'))" placeholder="Optional ref regex" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12">
                                          <label>Ref Value Regex</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                        </div>
                                      </div>
                                    </div>
                                    <p-button
                                      (click)="addNestedCondition(i, j)"
                                      label="Add Nested Condition"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                      [binary]="true"
                                      formControlName="targetConditionMatching"
                                      [inputId]="'targetConditionMatching' + i + j"
                                      [disabled]="isBusy"
                                    ></p-checkbox>
                                    <label [for]="'targetConditionMatching' + i + j" class="m-0 cursor-pointer">Target Condition Matching</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox
                                      [binary]="true"
                                      formControlName="reverseSearch"
                                      [inputId]="'reverseSearch' + i + j"
                                      [disabled]="isBusy"
                                    ></p-checkbox>
                                    <label [for]="'reverseSearch' + i + j" class="m-0 cursor-pointer">Reverse Search</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Tag</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('tag'))" placeholder="e.g., quiz_widgets_container" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Relative Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Context</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Regex</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('regex'))" placeholder="Optional ref regex" [disabled]="isBusy" />
                                </div>
                                <div class="col-12">
                                  <label>Ref Value Regex</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                </div>
                              </ng-container>

                              <!-- LIST fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'LIST'">
                                <div class="col-12 mb-2">
                                  <label>Target</label>
                                  <div formArrayName="target">
                                    <div
                                      *ngFor="let target of getConditionTargetArray(i, j).controls; let k = index"
                                      [formGroupName]="k"
                                      class="nested-form-group mb-3 p-3 border-round"
                                      style="background-color: #f8f9fa;"
                                    >
                                      <div class="flex justify-content-between align-items-center mb-2">
                                        <h6>Target {{ k + 1 }}</h6>
                                        <p-button
                                          (click)="getConditionTargetArray(i, j).removeAt(k)"
                                          icon="pi pi-trash"
                                          styleClass="p-button-text p-button-danger p-button-sm"
                                          [disabled]="isBusy"
                                        ></p-button>
                                      </div>
                                      <div class="grid p-fluid">
                                        <div class="col-12 mb-2">
                                          <label>Type<span class="red">*</span></label>
                                          <p-dropdown formControlName="type" [options]="['CLASS_NAME', 'TEXT_MATCH', 'CHILD_COUNT', 'META']" placeholder="Select type" [disabled]="isBusy"></p-dropdown>
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Description</label>
                                          <input pInputText formControlName="description" placeholder="Optional description" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <div class="flex align-items-center gap-2">
                                            <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'listTargetReadOnly' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                            <label [for]="'listTargetReadOnly' + i + j + k" class="m-0 cursor-pointer">Read Only</label>
                                          </div>
                                        </div>
                                        <ng-container *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CLASS_NAME' || getConditionTargetArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                          <div class="col-12 mb-2">
                                            <label>Values</label>
                                            <div formArrayName="values">
                                              <div *ngFor="let value of getTargetValuesArray(i, j, k).controls; let v = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="v" placeholder="e.g., android.widget.ListView" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeTargetValue(i, j, k, v)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addTargetValue(i, j, k)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Index</label>
                                            <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Indices</label>
                                            <div formArrayName="indices">
                                              <div *ngFor="let idx of getTargetIndicesArray(i, j, k).controls; let idxI = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="idxI" type="number" placeholder="e.g., 2" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeTargetIndex(i, j, k, idxI)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addTargetIndex(i, j, k)" label="Add Index" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionTargetArray(i, j).at(k).get('type')?.value === 'CLASS_NAME'">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'listTargetReverseSearch' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'listTargetReverseSearch' + i + j + k" class="m-0 cursor-pointer">Reverse Search</label>
                                            </div>
                                          </div>
                                        </ng-container>
                                        <div class="col-12 mb-2">
                                          <label>Ref Tag</label>
                                          <input pInputText [formControl]="$any(getTargetRefFormGroup(i, j, k).get('tag'))" placeholder="e.g., question_list" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Index</label>
                                          <input pInputText [formControl]="$any(getTargetRefFormGroup(i, j, k).get('index'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12">
                                          <label>Ref Relative Index</label>
                                          <input pInputText [formControl]="$any(getTargetRefFormGroup(i, j, k).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                        </div>
                                      </div>
                                    </div>
                                    <p-button
                                      (click)="getConditionTargetArray(i, j).push(createConditionFormGroup())"
                                      label="Add Target"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Item</label>
                                  <input pInputText formControlName="item" placeholder="e.g., QuestionItem" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Items</label>
                                  <div formArrayName="items">
                                    <div
                                      *ngFor="let item of getConditionItemsArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        placeholder="e.g., SectionItem"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="getConditionItemsArray(i, j).removeAt(k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                    <p-button
                                      (click)="getConditionItemsArray(i, j).push(createFormControl(''))"
                                      label="Add Item"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Item Class Name</label>
                                  <input
                                    pInputText
                                    formControlName="itemClassName"
                                    placeholder="e.g., android.widget.RelativeLayout"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Min Size</label>
                                  <input pInputText formControlName="minSize" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>To Index</label>
                                  <input pInputText formControlName="toIndex" type="number" placeholder="e.g., -2" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox [binary]="true" formControlName="targetConditionMatching" [inputId]="'listTargetConditionMatching' + i + j" [disabled]="isBusy"></p-checkbox>
                                    <label [for]="'listTargetConditionMatching' + i + j" class="m-0 cursor-pointer">Target Condition Matching</label>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Tag</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('tag'))" placeholder="e.g., question_list" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12">
                                  <label>Ref Context</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                </div>
                              </ng-container>

                              <!-- LAYOUT fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'LAYOUT'">
                                <div class="col-12 mb-2">
                                  <label>Layout<span class="red">*</span></label>
                                  <input
                                    pInputText
                                    formControlName="layout"
                                    placeholder="e.g., ResumeVisitScreen"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ignore Conditions</label>
                                  <div formArrayName="ignoreConditions">
                                    <div
                                      *ngFor="let ic of getConditionIgnoreConditionsArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        type="number"
                                        placeholder="e.g., 0"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="getConditionIgnoreConditionsArray(i, j).removeAt(k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                    <p-button
                                      (click)="getConditionIgnoreConditionsArray(i, j).push(createFormControl(null))"
                                      label="Add Ignore Condition"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <label>Description</label>
                                  <input
                                    pInputText
                                    formControlName="description"
                                    placeholder="e.g., Inherit rules from ResumeVisitScreen"
                                    [disabled]="isBusy"
                                  />
                                </div>
                              </ng-container>

                              <!-- OR fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'OR'">
                                <div class="col-12 mb-2">
                                  <label>Conditions</label>
                                  <div formArrayName="conditions">
                                    <div
                                      *ngFor="let nestedCondition of getConditionConditionsArray(i, j).controls; let k = index"
                                      [formGroupName]="k"
                                      class="nested-form-group mb-3 p-3 border-round"
                                      style="background-color: #f8f9fa;"
                                    >
                                      <div class="flex justify-content-between align-items-center mb-2">
                                        <h6>Condition {{ k + 1 }}</h6>
                                        <p-button
                                          (click)="removeNestedCondition(i, j, k)"
                                          icon="pi pi-trash"
                                          styleClass="p-button-text p-button-danger p-button-sm"
                                          [disabled]="isBusy"
                                        ></p-button>
                                      </div>
                                      <div class="grid p-fluid">
                                        <div class="col-12 mb-2">
                                          <label>Type<span class="red">*</span></label>
                                          <p-dropdown formControlName="type" [options]="['CHILD_COUNT', 'CLASS_NAME', 'TEXT_MATCH', 'CHILDREN', 'LIST', 'OR', 'NOT', 'META']" placeholder="Select type" [disabled]="isBusy"></p-dropdown>
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Description</label>
                                          <input pInputText formControlName="description" placeholder="Optional description" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <div class="flex align-items-center gap-2">
                                            <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'orNestedReadOnly' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                            <label [for]="'orNestedReadOnly' + i + j + k" class="m-0 cursor-pointer">Read Only</label>
                                          </div>
                                        </div>
                                        <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Min</label>
                                          <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CHILD_COUNT'">
                                          <label>Max</label>
                                          <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                        </div>
                                        <ng-container *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'CLASS_NAME' || getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                          <div class="col-12 mb-2">
                                            <label>Values</label>
                                            <div formArrayName="values">
                                              <div *ngFor="let value of getNestedConditionValuesArray(i, j, k).controls; let v = index" class="flex align-items-center gap-2 mb-2">
                                                <input pInputText [formControlName]="v" placeholder="e.g., android.widget.TextView" class="flex-1" [disabled]="isBusy" />
                                                <p-button (click)="removeNestedConditionValue(i, j, k, v)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                              </div>
                                              <p-button (click)="addNestedConditionValue(i, j, k)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <label>Index</label>
                                            <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="exact" [inputId]="'orNestedExact' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'orNestedExact' + i + j + k" class="m-0 cursor-pointer">Exact Match</label>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2">
                                            <div class="flex align-items-center gap-2">
                                              <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'orNestedReverseSearch' + i + j + k" [disabled]="isBusy"></p-checkbox>
                                              <label [for]="'orNestedReverseSearch' + i + j + k" class="m-0 cursor-pointer">Reverse Search</label>
                                            </div>
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <label>Class Name</label>
                                            <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                          </div>
                                          <div class="col-12 mb-2" *ngIf="getConditionConditionsArray(i, j).at(k).get('type')?.value === 'TEXT_MATCH'">
                                            <label>Regex</label>
                                            <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                          </div>
                                        </ng-container>
                                        <div class="col-12 mb-2">
                                          <label>Ref Tag</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('tag'))" placeholder="e.g., correction_comments" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Index</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('index'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Relative Index</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Context</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12 mb-2">
                                          <label>Ref Regex</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('regex'))" placeholder="Optional ref regex" [disabled]="isBusy" />
                                        </div>
                                        <div class="col-12">
                                          <label>Ref Value Regex</label>
                                          <input pInputText [formControl]="$any(getNestedConditionRefFormGroup(i, j, k).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                        </div>
                                      </div>
                                    </div>
                                    <p-button
                                      (click)="addNestedCondition(i, j)"
                                      label="Add Condition"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <label>Description</label>
                                  <input
                                    pInputText
                                    formControlName="description"
                                    placeholder="e.g., Check for either an ExpandableListView or a regular ListView"
                                    [disabled]="isBusy"
                                  />
                                </div>
                              </ng-container>

                              <!-- NOT fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'NOT'">
                                <div class="col-12 mb-2" [formGroup]="getNotConditionFormGroup(i, j)">
                                  <label>Negated Condition Type<span class="red">*</span></label>
                                  <p-dropdown
                                    formControlName="type"
                                    [options]="['CHILD_COUNT', 'CLASS_NAME', 'TEXT_MATCH', 'CHILDREN', 'LIST', 'LAYOUT', 'OR', 'NOT', 'META']"
                                    placeholder="Select condition type"
                                    [disabled]="isBusy"
                                  ></p-dropdown>
                                </div>

                                <div class="col-12 mb-2" [formGroup]="getNotConditionFormGroup(i, j)">
                                  <label>Description</label>
                                  <input
                                    pInputText
                                    formControlName="description"
                                    placeholder="e.g., Check for other input widgets"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2" [formGroup]="getNotConditionFormGroup(i, j)">
                                  <div class="flex align-items-center gap-2">
                                    <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'notReadOnly' + i + j" [disabled]="isBusy"></p-checkbox>
                                    <label [for]="'notReadOnly' + i + j" class="m-0 cursor-pointer">Read Only</label>
                                  </div>
                                </div>

                                <!-- Nested condition fields -->
                                <ng-container [formGroup]="getNotConditionFormGroup(i, j)">
                                  <ng-container *ngIf="getNotConditionFormGroup(i, j).get('type')?.value === 'CHILD_COUNT'">
                                    <div class="col-12 mb-2">
                                      <label>Min</label>
                                      <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Max</label>
                                      <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>

                                  <ng-container *ngIf="getNotConditionFormGroup(i, j).get('type')?.value === 'CLASS_NAME'">
                                    <div class="col-12 mb-2">
                                      <label>Values</label>
                                      <div formArrayName="values">
                                        <div *ngFor="let v of getNotConditionValuesArray(i, j).controls; let k = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="k" placeholder="e.g., android.widget.TextView" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeNotConditionValue(i, j, k)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addNotConditionValue(i, j)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Index</label>
                                      <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Indices</label>
                                      <div formArrayName="indices">
                                        <div *ngFor="let idx of getNotConditionIndicesArray(i, j).controls; let k = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="k" type="number" placeholder="e.g., -1" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeNotConditionIndex(i, j, k)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addNotConditionIndex(i, j)" label="Add Index" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Regex</label>
                                      <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                    </div>

                                    <div class="col-12 mb-2">
                                      <div class="flex align-items-center gap-2">
                                        <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'notReverseSearch' + i + j" [disabled]="isBusy"></p-checkbox>
                                        <label [for]="'notReverseSearch' + i + j" class="m-0 cursor-pointer">Reverse Search</label>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Ref Tag</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('tag'))" placeholder="Optional ref tag" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Index</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Relative Index</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Regex</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('regex'))" placeholder="Optional ref regex" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12">
                                      <label>Ref Value Regex</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>

                                  <ng-container *ngIf="getNotConditionFormGroup(i, j).get('type')?.value === 'TEXT_MATCH'">
                                    <div class="col-12 mb-2">
                                      <label>Values</label>
                                      <div formArrayName="values">
                                        <div *ngFor="let v of getNotConditionValuesArray(i, j).controls; let k = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="k" placeholder="e.g., Next" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeNotConditionValue(i, j, k)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addNotConditionValue(i, j)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Indices</label>
                                      <div formArrayName="indices">
                                        <div *ngFor="let idx of getNotConditionIndicesArray(i, j).controls; let k = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="k" type="number" placeholder="e.g., -1" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeNotConditionIndex(i, j, k)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addNotConditionIndex(i, j)" label="Add Index" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <div class="flex align-items-center gap-2">
                                        <p-checkbox [binary]="true" formControlName="exact" [inputId]="'notExact' + i + j" [disabled]="isBusy"></p-checkbox>
                                        <label [for]="'notExact' + i + j" class="m-0 cursor-pointer">Exact Match</label>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-2">
                                      <div class="flex align-items-center gap-2">
                                        <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'notTextMatchReverseSearch' + i + j" [disabled]="isBusy"></p-checkbox>
                                        <label [for]="'notTextMatchReverseSearch' + i + j" class="m-0 cursor-pointer">Reverse Search</label>
                                      </div>
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Class Name</label>
                                      <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Regex</label>
                                      <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                    </div>

                                    <div class="col-12 mb-2">
                                      <label>Ref Tag</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('tag'))" placeholder="Optional ref tag" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Index</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Regex</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('regex'))" placeholder="Optional ref regex" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12">
                                      <label>Ref Value Regex</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>

                                  <ng-container *ngIf="getNotConditionFormGroup(i, j).get('type')?.value === 'META'">
                                    <div class="col-12 mb-2">
                                      <label>Class Name</label>
                                      <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Class Names</label>
                                      <div formArrayName="classNames">
                                        <div *ngFor="let cn of getNotConditionClassNamesArray(i, j).controls; let k = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="k" placeholder="e.g., android.widget.TableRow" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeNotConditionClassName(i, j, k)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addNotConditionClassName(i, j)" label="Add Class Name" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Ref Context</label>
                                      <input pInputText [formControl]="$any(getNotConditionRefFormGroup(i, j).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ng-container>

                              <!-- META fields -->
                              <ng-container *ngIf="getConditionsFormArray(i).at(j).get('type')?.value === 'META'">
                                <div class="col-12 mb-2">
                                  <label>Class Name</label>
                                  <input
                                    pInputText
                                    formControlName="className"
                                    placeholder="e.g., android.widget.Button"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Class Names</label>
                                  <div formArrayName="classNames">
                                    <div
                                      *ngFor="let className of getConditionClassNamesArray(i, j).controls; let k = index"
                                      class="flex align-items-center gap-2 mb-2"
                                    >
                                      <input
                                        pInputText
                                        [formControlName]="k"
                                        placeholder="e.g., android.widget.TableRow"
                                        class="flex-1"
                                        [disabled]="isBusy"
                                      />
                                      <p-button
                                        (click)="removeConditionClassName(i, j, k)"
                                        icon="pi pi-trash"
                                        styleClass="p-button-text p-button-danger p-button-sm"
                                        [disabled]="isBusy"
                                      ></p-button>
                                    </div>
                                    <p-button
                                      (click)="addConditionClassName(i, j)"
                                      label="Add Class Name"
                                      styleClass="p-button-text p-button-sm"
                                      [disabled]="isBusy"
                                    ></p-button>
                                  </div>
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Index</label>
                                  <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Regex</label>
                                  <input pInputText formControlName="regex" placeholder="e.g., \\w+" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>From Index</label>
                                  <input pInputText formControlName="fromIndex" type="number" placeholder="e.g., 2" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2" [formGroup]="$any(getConditionsFormArray(i).at(j).get('childCount'))">
                                  <label>Child Count Min</label>
                                  <input pInputText formControlName="min" type="number" placeholder="Min child count" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2" [formGroup]="$any(getConditionsFormArray(i).at(j).get('childCount'))">
                                  <label>Child Count Max</label>
                                  <input pInputText formControlName="max" type="number" placeholder="Max child count" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Tag</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('tag'))" placeholder="e.g., contact_name_container" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('index'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Relative Index</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('relativeIndex'))" type="number" [disabled]="isBusy" />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Context</label>
                                  <input
                                    pInputText
                                    [formControl]="$any(getConditionRefFormGroup(i, j).get('context'))"
                                    placeholder="e.g., visit_actions"
                                    [disabled]="isBusy"
                                  />
                                </div>
                                <div class="col-12 mb-2">
                                  <label>Ref Value Regex</label>
                                  <input pInputText [formControl]="$any(getConditionRefFormGroup(i, j).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                </div>
                                <div class="col-12">
                                  <label>Description</label>
                                  <input
                                    pInputText
                                    formControlName="description"
                                    placeholder="e.g., Container for quiz correction item"
                                    [disabled]="isBusy"
                                  />
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Previous Layouts -->
                    <div class="gc-form-section mt-4" *ngIf="!isLayoutCollapsed(i)">
                      <div class="gc-form-section-heading" [class.collapsed]="isPreviousLayoutsCollapsed(i)">
                        <h4 class="m-0 cursor-pointer" (click)="togglePreviousLayouts(i)">Previous Layouts</h4>
                        <div class="flex align-items-center gap-2">
                          <p-button
                            *ngIf="!isPreviousLayoutsCollapsed(i)"
                            (click)="addPreviousLayout(i); $event.stopPropagation()"
                            label="Add"
                            styleClass="button-sm add-icon"
                            [disabled]="isBusy"
                          ></p-button>
                          <i
                            class="pi cursor-pointer"
                            [ngClass]="isPreviousLayoutsCollapsed(i) ? 'pi-chevron-right' : 'pi-chevron-down'"
                            (click)="togglePreviousLayouts(i)"
                          ></i>
                        </div>
                      </div>

                      <div class="sidebar-form" *ngIf="!isPreviousLayoutsCollapsed(i)">
                        <div formArrayName="previousLayouts">
                          <div
                            *ngFor="let prevLayout of getPreviousLayoutsFormArray(i).controls; let k = index"
                            class="flex align-items-center gap-2 mb-2"
                          >
                            <input
                              pInputText
                              [formControlName]="k"
                              placeholder="e.g., layout1"
                              class="flex-1"
                              [disabled]="isBusy"
                            />
                            <button
                              pButton
                              type="button"
                              (click)="removePreviousLayout(i, k)"
                              icon="pi pi-trash"
                              class="p-button-text p-button-danger"
                              [disabled]="isBusy"
                            ></button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sub Layouts -->
                    <div class="gc-form-section mt-4" *ngIf="!isLayoutCollapsed(i)">
                      <div class="gc-form-section-heading" [class.collapsed]="isSubLayoutsCollapsed(i)">
                        <h4 class="m-0 cursor-pointer" (click)="toggleSubLayouts(i)">Sub Layouts</h4>
                        <i
                          class="pi cursor-pointer"
                          [ngClass]="isSubLayoutsCollapsed(i) ? 'pi-chevron-right' : 'pi-chevron-down'"
                          (click)="toggleSubLayouts(i)"
                        ></i>
                      </div>

                      <div class="sidebar-form" *ngIf="!isSubLayoutsCollapsed(i)">
                        <div [formGroup]="getSubLayoutsFormGroup(i)">
                          <!-- Add New Sub Layout Inline -->
                          <div class="mb-3">
                            <label>Add Sub Layout</label>
                            <div class="flex align-items-center gap-2">
                              <input
                                pInputText
                                #newSubLayoutInput
                                [(ngModel)]="newSubLayoutNames[i]"
                                placeholder="e.g., QuestionItem"
                                class="flex-1"
                                (keyup.enter)="addSubLayoutInline(i, newSubLayoutInput.value)"
                                (input)="onSubLayoutInputChange(i)"
                                [disabled]="isBusy"
                              />
                              <p-button
                                (click)="addSubLayoutInline(i, newSubLayoutInput.value)"
                                label="Add"
                                styleClass="btn-cancel p-button-sm sub-layout-add-button"
                                [disabled]="isBusy"
                              ></p-button>
                            </div>
                          </div>

                          <!-- Existing Sub Layouts -->
                          <div
                            *ngFor="let subLayoutName of getSubLayoutNames(i)"
                            class="nested-form-group mb-3"
                          >
                            <div class="flex justify-content-between align-items-center mb-3">
                              <h5 class="m-0">{{ subLayoutName }}</h5>
                              <button
                                pButton
                                type="button"
                                (click)="removeSubLayout(i, subLayoutName)"
                                icon="pi pi-trash"
                                class="p-button-text p-button-danger"
                                [disabled]="isBusy"
                              ></button>
                            </div>
                            <div [formArrayName]="subLayoutName">
                              <div
                                *ngFor="let condition of getSubLayoutFormArray(i, subLayoutName).controls; let k = index"
                                [formGroupName]="k"
                                class="nested-form-group mb-3 p-3 border-round"
                                style="background-color: #f8f9fa;"
                              >
                                <div class="flex justify-content-between align-items-center mb-2">
                                  <h6 class="m-0">Condition {{ k + 1 }} – {{ condition.get('type')?.value }}</h6>
                                  <button pButton type="button" (click)="removeSubLayoutCondition(i, subLayoutName, k)" icon="pi pi-trash" class="p-button-text p-button-danger" [disabled]="isBusy"></button>
                                </div>
                                <div class="grid p-fluid">
                                  <div class="col-12 mb-2">
                                    <label>Type<span class="red">*</span></label>
                                    <p-dropdown formControlName="type" [options]="['CHILD_COUNT', 'CLASS_NAME', 'TEXT_MATCH', 'CHILDREN', 'LIST', 'LAYOUT', 'OR', 'NOT', 'META']" placeholder="Select type" [disabled]="isBusy"></p-dropdown>
                                  </div>
                                  <div class="col-12 mb-2">
                                    <label>Description</label>
                                    <input pInputText formControlName="description" placeholder="Optional description" [disabled]="isBusy" />
                                  </div>
                                  <div class="col-12 mb-2">
                                    <div class="flex align-items-center gap-2">
                                      <p-checkbox [binary]="true" formControlName="readOnly" [inputId]="'subLayoutReadOnly' + i + subLayoutName + k" [disabled]="isBusy"></p-checkbox>
                                      <label [for]="'subLayoutReadOnly' + i + subLayoutName + k" class="m-0 cursor-pointer">Read Only</label>
                                    </div>
                                  </div>

                                  <!-- CHILD_COUNT fields -->
                                  <ng-container *ngIf="condition.get('type')?.value === 'CHILD_COUNT'">
                                    <div class="col-12 mb-2">
                                      <label>Min</label>
                                      <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Max</label>
                                      <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>

                                  <!-- CLASS_NAME / TEXT_MATCH fields -->
                                  <ng-container *ngIf="condition.get('type')?.value === 'CLASS_NAME' || condition.get('type')?.value === 'TEXT_MATCH'">
                                    <div class="col-12 mb-2">
                                      <label>Values</label>
                                      <div formArrayName="values">
                                        <div *ngFor="let v of getSubLayoutConditionValuesArray(i, subLayoutName, k).controls; let vi = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="vi" placeholder="e.g., android.widget.TextView" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeSubLayoutConditionValue(i, subLayoutName, k, vi)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addSubLayoutConditionValue(i, subLayoutName, k)" label="Add Value" styleClass="btn-cancel p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Index</label>
                                      <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2" *ngIf="condition.get('type')?.value === 'TEXT_MATCH'">
                                      <div class="flex align-items-center gap-2">
                                        <p-checkbox [binary]="true" formControlName="exact" [inputId]="'slExact' + i + subLayoutName + k" [disabled]="isBusy"></p-checkbox>
                                        <label [for]="'slExact' + i + subLayoutName + k" class="m-0 cursor-pointer">Exact Match</label>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-2" *ngIf="condition.get('type')?.value === 'TEXT_MATCH'">
                                      <label>Class Name</label>
                                      <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Regex</label>
                                      <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <div class="flex align-items-center gap-2">
                                        <p-checkbox [binary]="true" formControlName="reverseSearch" [inputId]="'slReverseSearch' + i + subLayoutName + k" [disabled]="isBusy"></p-checkbox>
                                        <label [for]="'slReverseSearch' + i + subLayoutName + k" class="m-0 cursor-pointer">Reverse Search</label>
                                      </div>
                                    </div>
                                  </ng-container>

                                  <!-- META fields -->
                                  <ng-container *ngIf="condition.get('type')?.value === 'META'">
                                    <div class="col-12 mb-2">
                                      <label>Class Name</label>
                                      <input pInputText formControlName="className" placeholder="e.g., android.widget.Button" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Class Names</label>
                                      <div formArrayName="classNames">
                                        <div *ngFor="let cn of getSubLayoutConditionClassNamesArray(i, subLayoutName, k).controls; let ci = index" class="flex align-items-center gap-2 mb-2">
                                          <input pInputText [formControlName]="ci" placeholder="e.g., android.widget.TableRow" class="flex-1" [disabled]="isBusy" />
                                          <p-button (click)="removeSubLayoutConditionClassName(i, subLayoutName, k, ci)" icon="pi pi-trash" styleClass="p-button-text p-button-danger p-button-sm" [disabled]="isBusy"></p-button>
                                        </div>
                                        <p-button (click)="addSubLayoutConditionClassName(i, subLayoutName, k)" label="Add Class Name" styleClass="p-button-text p-button-sm" [disabled]="isBusy"></p-button>
                                      </div>
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Index</label>
                                      <input pInputText formControlName="index" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>Regex</label>
                                      <input pInputText formControlName="regex" placeholder="Optional regex" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2">
                                      <label>From Index</label>
                                      <input pInputText formControlName="fromIndex" type="number" placeholder="e.g., 2" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2" [formGroup]="getSubLayoutConditionChildCountFormGroup(i, subLayoutName, k)">
                                      <label>Child Count Min</label>
                                      <input pInputText formControlName="min" type="number" [disabled]="isBusy" />
                                    </div>
                                    <div class="col-12 mb-2" [formGroup]="getSubLayoutConditionChildCountFormGroup(i, subLayoutName, k)">
                                      <label>Child Count Max</label>
                                      <input pInputText formControlName="max" type="number" [disabled]="isBusy" />
                                    </div>
                                  </ng-container>

                                  <!-- Ref fields (common) -->
                                  <div class="col-12 mb-2">
                                    <label>Ref Tag</label>
                                    <input pInputText [formControl]="$any(getSubLayoutConditionRefFormGroup(i, subLayoutName, k).get('tag'))" placeholder="Optional ref tag" [disabled]="isBusy" />
                                  </div>
                                  <div class="col-12 mb-2">
                                    <label>Ref Index</label>
                                    <input pInputText [formControl]="$any(getSubLayoutConditionRefFormGroup(i, subLayoutName, k).get('index'))" type="number" [disabled]="isBusy" />
                                  </div>
                                  <div class="col-12 mb-2">
                                    <label>Ref Context</label>
                                    <input pInputText [formControl]="$any(getSubLayoutConditionRefFormGroup(i, subLayoutName, k).get('context'))" placeholder="Optional ref context" [disabled]="isBusy" />
                                  </div>
                                  <div class="col-12">
                                    <label>Ref Value Regex</label>
                                    <input pInputText [formControl]="$any(getSubLayoutConditionRefFormGroup(i, subLayoutName, k).get('valueRegex'))" placeholder="Optional ref valueRegex" [disabled]="isBusy" />
                                  </div>
                                </div>
                              </div>
                              <p-button
                                (click)="getSubLayoutFormArray(i, subLayoutName).push(createConditionFormGroup())"
                                label="Add Condition"
                                styleClass="btn-cancel p-button-sm"
                                [disabled]="isBusy"
                              ></p-button>
                            </div>
                          </div>
                          <p *ngIf="getSubLayoutNames(i).length === 0" class="text-muted">No sub layouts defined</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="flex justify-content-end gap-3 mt-4">
              <p-button
                (click)="onDialogHide()"
                label="Cancel"
                styleClass="btn-cancel"
                [disabled]="isBusy"
              ></p-button>
              <p-button
                (click)="onSubmit()"
                [label]="isEditMode ? 'Update Layout' : 'Create Layout'"
                [disabled]="isBusy"
                [loading]="isBusy"
              ></p-button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ng-template #loadingTemplate>
      <div class="p-4 text-center">Loading form...</div>
    </ng-template>
  </ng-template>
</p-sidebar>


